import { LoadingPage } from 'components/common/Loading';
import { useGetAppContextSubscription } from 'queries/AppContextSubscription/appContextSubscription.queries';
import React, { FC, ReactNode } from 'react';
import { matchPath, useLocation } from 'react-router';
import { RoutePaths } from 'routes/RoutePaths';
import { useGetUserInfo } from 'queries/UserInfo/userInfo.queries';

const UserHeader: FC<{ children?: ReactNode }> = ({ children }) => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const otherUser = query.get('icId') || undefined;

    const { data: appContext, isFetching: isFetchingAppContext } = useGetAppContextSubscription();
    const { data: user, isFetching: isFetchingUser } = useGetUserInfo(otherUser);

    const currentUser = user ?? appContext?.loggedUser;

    const getCurrentPageTitle = (): string => {
        if (matchPath(RoutePaths.Subscriptions.AllActive.route, location.pathname)) {
            return RoutePaths.Subscriptions.AllActive.title;
        }
        else if (matchPath(RoutePaths.Subscriptions.Manage.route, location.pathname)) {
            return RoutePaths.Subscriptions.Manage.title;
        }
        else if (matchPath(RoutePaths.History.route, location.pathname)) {
            return RoutePaths.History.title;
        }
        else {
            return '';
        }
    };

    if (isFetchingAppContext || isFetchingUser) {
        return <LoadingPage />;
    };

    if (matchPath(RoutePaths.Errors.NotAuthorized.route, location.pathname)) {
        return <div style={{ height: '90px' }} />;
    }

    return <div className="container-xxl py-4 bg-lvl">
        <div className="d-flex flex-column flex-lg-row gap-3 align-items-baseline justify-content-lg-between">
            <div className="d-flex gap-1 flex-column">
                <div className="display-3">{currentUser?.fullName}&apos;s {getCurrentPageTitle()}</div>
                <div className="d-flex align-items-center pt-2">
                    <span className="badge badge-md badge-outline-primary">
                        Mifid 2 status : {currentUser?.mifid2StatusImpacted ? 'In scope' : 'Out of scope'}
                    </span>
                </div>
            </div>
            {children}
        </div>
    </div>;
};

export default UserHeader;
